import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";
import { useTheme } from "@emotion/react";

const TransactionsTable = ({ transactions }) => {
  const theme = useTheme();

  if (!transactions || !transactions.length) {
    return <div><Typography variant="h2">No transactions available.</Typography></div>;
  }
  return (
    <Paper
      elevation={3}
      sx={{
        p: 1,
        mb: 3,
        backgroundColor: theme.palette.background.dark,
      }}
    >
      <TableContainer component={Paper} sx={{ overflowX: "auto" }}>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Transaction Code</TableCell>
              <TableCell>Transaction Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Running Balance</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.map((tx, index) => (
              <TableRow key={index}>
                <TableCell>{tx.effectiveDate}</TableCell>
                <TableCell>{tx.transactionType}</TableCell>
                <TableCell>{tx.transactionCode}</TableCell>
                <TableCell>{tx.transactionCodeName}</TableCell>
                <TableCell>
                  {tx.description?.description1 || ""}{" "}
                  {tx.description?.description2 || ""}{" "}
                  {tx.description?.description3 || ""}{" "}
                  {tx.description?.description4 || ""}
                </TableCell>
                <TableCell>{tx.amount}</TableCell>
                <TableCell>{tx.runningBalance}</TableCell>
                <TableCell>{tx.transactionStatus}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default TransactionsTable;
